var tw = tw || {};
tw.ModalSteps = (function () {
  var init = function () {
    //console.log("is cookie set " + isCookieSet());
    var hideModal = isCookieSet();
    if (hideModal === false) {
      $('.js-modal-trigger').modaal({
        start_open: true,
        background: "#ddd",
        after_open: modalOpen
      });
    }
  },
    modalOpen = function () {
      //console.log("modal is open");
      setCookie();
      //bad temporary hack because slick slider was calculating width wrong
      var width = ($('.modaal-content-container').width() - 30);
      initSlider(width);
      
    },
    setCookie = function () {
      //console.log("setting cookie");
      $.cookie('hideInstructionModal', true, { expires: 1, path: '/' });
    },
    isCookieSet = function () {
      if ($.cookie('hideInstructionModal') === undefined) {
        return false;
      } else {
        return true;
      }
    },
    initSlider = function (width) {
      
      $('.js-instruction-slider').width(width).on('init', function (event,slick) {
        $('.js-instruction-slider').removeClass('invisible');
        sliderNext(slick);
      }).slick({
        infinite: false,
        arrows: true,
        dots: true,
        dotsClass: 'carousel-dots',
        prevArrow: '<button class="Media-Scroller_Previous-Button" type="button"><span class="sr-only">Last Instruction</span></button>',
        nextArrow: '<button class="Media-Scroller_Next-Button" type="button"><span class="sr-only">Next Instruction</span></button>',
      });
    },
    sliderNext = function () {
      var totalSlide = $('.slick-track').children().length;
      var lastSlide = totalSlide - 1;
      var $slider = $('.js-instruction-slider');
      //console.log("totalSlide " + totalSlide + " lastSlide " + lastSlide);

      $('.js-instruction-next').click(function () {
        $slider.slick('slickNext');
      }); 

      $slider.on('afterChange', function () {
        var currentSlide = $slider.slick('slickCurrentSlide');
        //console.log(currentSlide);

        if (currentSlide === lastSlide) {
          $('.js-instruction-next').text('OK').on("click.close", function () {
            $('.modaal-close').click();
          });
        } else {
          $('.js-instruction-next').text('Next').off('click.close');
        }
      });
      
    }
  $(function () {
    init();
  });
  return {
    
  }
}());